import React, { Component } from "react";
import Events from "../../components/dashboard/Events";
import Fees from "../../components/dashboard/Fees";
import PendingApproval from "../../components/dashboard/PendingApproval";
import ProspectsCorporateMember from "../../components/dashboard/ProspectsCorporateMember";
import DashboardServices from "../../services/axiosServices/apiServices/DashboardServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import { Navigate } from "react-router-dom";
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.getDashboardServices = new DashboardServices();
    this.swalServices = new SwalServices();
    this.state = {
      isLoading: false,
      route: null,
      entries: "",

      dashboardDetails: {


        totalProspects: 0,
        submitted: 0,
        pendingMembershipCommittee: 0,
        pendingManagementCommittee: 0,
        membershipCommitteeApproved: 0,
        managementCommitteeApproved: 0,
        clarifications: 0,
        pendingPayment: 0,
        completed: 0,
        totalActiveMembers: 0,
        expiryInThirdYear: 0,
        expiryInSecondYear: 0,

        
        businessMatchingPaid: 0,
        businessMatchingPendingPayment: 0,
        businessMatchingTotalAmount: 0,
        closedLost: 0,
        closedSuccessful: 0,
        closedToRevisit: 0,
        eventsPaid: 0,
        eventsPendingPayment: 0,
        eventsTotalAmount: 0,
        expiryWithin30: 0,
        expiryWithin45: 0,
        expiryWithin60: 0,
        inProgress: 0,
        membershipAssociateFee: 0,
        // membershipQualifyingFee: 0,
        membershipOrdinaryFee: 0,
        membershipTotalAmount: 0,
        notStarted: 0,
        renewedlast7: 0,
        sponsorshipCorporateFee: 0,
        sponsorshipIndividualFee: 0,
        sponsorshipTotalAmount: 0,
        totalCorporateMember: 0,
        adminDashboardEventDetailList: [],
        adminDashboardPendingApprovalList: [],
        currentDate: "2023-02-09 17:40:13.070",
        totalActiveCorporateMembers: 0,
        totalInactiveCorporateMembers: 0,
        totalInactiveCorporateMembersinTaskList: 0,
        renewalMemberProratedIn2025: "",
        activeMember:""
      },
      roleId: 0,
    };
  }

  getAdminDashboardDetail = () => {
    this.setState({ isLoading: true });
    this.getDashboardServices.getAdminDashboardDetail().then((response) => {
      if (response != null) {
        this.setState({ dashboardDetails: response });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  componentDidMount() {
    let cookies = getAuthProps();
    if (cookies && cookies.roleId > 0) {
      this.setState({ roleId: cookies.roleId })
    }
    this.getAdminDashboardDetail();
  }
 
  handleRedirectforProspect = (storageKey, storageValue) => {
    localStorage.setItem(storageKey, storageValue);
    this.setState({ route: "/Membership/MembershipTaskList" }); 
  };

  handleRedirectforCorporate = (storageKey, storageValue) => {
    localStorage.setItem(storageKey, storageValue);
    this.setState({ route: "/Membership/MembershipRenewalDashboard" }); 
  };
 

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
  }
    return (
      <div className="main-body-section bg-white h-auto justify-between">
        {/* Prospects Corporate Member Start */}
        <ProspectsCorporateMember
          dashboardDetails={this.state.dashboardDetails}
          redirectToProspect={this. handleRedirectforProspect}
          redirecToCorporate = {this.handleRedirectforCorporate}
        />
        {/* Prospects Corporate Member Ends */}

        {/* PendingApproval Start */}
        {/* <PendingApproval
          dashboardDetails={this.state.dashboardDetails}
        /> */}
        {/* PendingApproval End */}

        {/* Events Start */}
        {/* <Events
          dashboardDetails={this.state.dashboardDetails}
        /> */}
        {/* Events End */}

        {/* Fees Start */}
        {/* <Fees
          dashboardDetails={this.state.dashboardDetails}
        /> */}
        {/* Fees End */}
      </div>
    );
  }
}
